import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

/**
 * Notifications preferences — deferred to Phase 2. Per-user toggle table
 * (in-app / email / off) for each notification type, plus a per-project
 * override matrix. Requires a new notification_preferences table + wrapping
 * every existing createNotification call with a preference check.
 */
export function NotificationsSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Notifications"
      description="Toggle in-app + email delivery per notification type. Deferred to Phase 2 alongside the @Mentions parser and Assigned-to-you feature."
    />
  );
}
